<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div v-if="visible" class="modal-overlay" @click.self="close">
      <div class="custom-modal">
        <div class="modal-header">
          <h3>选择获取方式</h3>
          <button class="close-btn" @click="close">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        
        <div class="modal-body">
          <div class="tip-text">
            提示：部分渠道可能需要关注公众号或登录后获取提取码。
          </div>
          
          <div class="download-options">
            <button 
              v-for="btn in buttons" 
              :key="btn.type"
              class="download-opt-btn"
              @click="select(btn.type)"
              :title="btn.title"
            >
              <div class="btn-icon">
                <i :class="btn.icon"></i>
              </div>
              <div class="btn-info">
                <span class="btn-label">{{ btn.label }}</span>
                <span class="btn-desc">{{ btn.title }}</span>
              </div>
              <i class="fa-solid fa-chevron-right arrow"></i>
            </button>
          </div>
        </div>
        
        <div class="modal-footer">
          <button class="cancel-btn" @click="close">取消</button>
        </div>
      </div>
    </div>
  </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'DownloadModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visible', 'select'],
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    select(type) {
      this.$emit('select', type)
      this.close()
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-dialog);

}

.custom-modal {
  background: rgba(255, 255, 255, 0.7);

  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 28px;
  width: 90%;
  max-width: 480px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 85vh;
}

.modal-header {
  padding: 25px 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
}

.modal-header h3 {
  margin: 0;
  font-family: '猫啃网糖圆体';
  font-size: 1.25em;
  color: #1a1a1a;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  flex: 1;
  overflow-y: auto;
}

.tip-text {
  margin-bottom: 25px; 
  font-size: 0.9em;
  line-height: 1.5;
  background: rgba(230, 162, 60, 0.15);
  padding: 12px 16px;
  border-radius: 12px;
  color: #e6a23c;
  display: flex;
  align-items: center;
  border: 1px solid rgba(230, 162, 60, 0.2);
}

.tip-text::before {
    content: '\f06a';
    font-family: 'Font Awesome 6 Free';
    font-weight: 900;
    margin-right: 8px;
}

.download-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.download-opt-btn {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 14px 20px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  text-align: left;
}

.download-opt-btn:hover {
  border-color: #4CAF50;
  background: rgba(255, 255, 255, 0.7);
  transform: translateX(8px) scale(1.02);
  box-shadow: 0 10px 25px rgba(76, 175, 80, 0.15);
}

.btn-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(0, 113, 227, 0.1));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  color: #4CAF50;
  font-size: 1.3em;
  border: 1px solid rgba(76, 175, 80, 0.1);
}

.btn-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.btn-label {
  font-weight: bold;
  color: #333;
  margin-bottom: 2px;
  font-family: '爱点风雅黑';
  font-size: 1.05em;
}

.btn-desc {
  font-size: 0.8em;
  color: #555; /* 从 #999 加深 */
}

.arrow {
  color: #ccc;
  font-size: 0.9em;
}

.modal-footer {
  padding: 20px 30px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.1);
}

.cancel-btn {
  padding: 10px 25px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 0.5);
  color: #666;
  border-radius: 18px;
  cursor: pointer;
  font-family: '爱点风雅黑';
  transition: all 0.3s;
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.8);
  border-color: rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

/* Dark Theme Support */
.dark-theme .custom-modal {
  background: rgba(30, 30, 30, 0.7);
  color: #f5f5f7;
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
}

.dark-theme .modal-header h3 {
  color: #f5f5f7;
}

.dark-theme .btn-label {
  color: #f5f5f7;
}

.dark-theme .btn-desc {
  color: rgba(255, 255, 255, 0.5);
}

.dark-theme .modal-header, .dark-theme .modal-footer {
  border-color: rgba(255, 255, 255, 0.05);
  background: rgba(0, 0, 0, 0.2);
}

.dark-theme .tip-text {
  background: rgba(230, 162, 60, 0.1);
  border-color: rgba(230, 162, 60, 0.15);
}

.dark-theme .download-opt-btn {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.05);
}

.dark-theme .download-opt-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: #4CAF50;
}

.dark-theme .btn-icon {
  background: rgba(76, 175, 80, 0.15);
  border-color: rgba(76, 175, 80, 0.2);
}

.dark-theme .cancel-btn {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: #ccc;
}

/* Animations (from UrgeUpdateModal) */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .custom-modal {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-fade-leave-active .custom-modal {
  transition: transform 0.3s ease-in;
}

.modal-fade-enter-from .custom-modal {
  transform: scale(0.9) translateY(10px);
}

.modal-fade-leave-to .custom-modal {
  transform: scale(0.95) translateY(10px);
}

@media (max-width: 480px) {
  .custom-modal {
    width: 100%;
    border-radius: 20px 20px 0 0;
    position: absolute;
    bottom: 0;
    margin: 0;
    max-width: none;
    max-height: 90vh;
  }
  
  .modal-overlay {
    align-items: flex-end;
  }
  
  .modal-fade-enter-from .custom-modal,
  .modal-fade-leave-to .custom-modal {
    transform: translateY(100%);
  }
}
</style>
